import { createContext, useState, useContext } from 'react';

// Create the context
const OverrideContext = createContext();

// Create provider component
export const OverrideProvider = ({ children }) => {
    const [overrideUpdateCounter, setOverrideUpdateCounter] = useState(0);

    return (
        <OverrideContext.Provider value={{ overrideUpdateCounter, setOverrideUpdateCounter }}>
            {children}
        </OverrideContext.Provider>
    );
};

// Custom hook to use the context
export const useOverride = () => {
    const context = useContext(OverrideContext);
    if (!context) {
        throw new Error('useOverride must be used within an OverrideProvider');
    }
    return context;
};